var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._g({class:['button', { 'button--loading': _vm.isLoading }],attrs:{"href":_vm.href,"role":_vm.href ? 'link' : 'button'}},_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }